export interface DeviceInRange {
  rssi: number,
  id: string
}

export function rssiString(deviceInRange: DeviceInRange | undefined) {
  if (!deviceInRange) return '?';

  return `${deviceInRange.rssi}`;
}

export function ascendingRssi(a: DeviceInRange, b: DeviceInRange) {
  return b.rssi - a.rssi;
}
